import { Modal, Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import type { PatientMeasurementRecord } from '../types';
import {
  formatBiologicalSex,
  formatDateTimeValue,
  formatMeasurementField,
  formatMeasurementValue,
} from '../utils/formatters';

interface PatientMeasurementViewModalProps {
  measurement: PatientMeasurementRecord | null;
  opened: boolean;
  onClose: () => void;
}

export function PatientMeasurementViewModal({
  measurement,
  opened,
  onClose,
}: PatientMeasurementViewModalProps) {
  const fields = (measurement?.fields ?? []).filter(
    field => field.value.trim().length > 0
  );

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Dettaglio rilevazione'
      centered
      size='lg'
    >
      {measurement == null ? null : (
        <Stack gap='md'>
          <Text size='sm' c='dimmed'>
            Registrata il {formatDateTimeValue(measurement.createdAt)}
          </Text>

          {measurement.biologicalSex != null || measurement.heightCm != null ? (
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing='xs'>
              {measurement.biologicalSex != null ? (
                <Paper withBorder radius='sm' p='xs' bg='gray.0'>
                  <Text size='xs' c='dimmed' tt='uppercase' fw={600}>
                    Sesso biologico
                  </Text>
                  <Text size='sm' fw={700}>
                    {formatBiologicalSex(measurement.biologicalSex)}
                  </Text>
                </Paper>
              ) : null}
              {measurement.heightCm != null ? (
                <Paper withBorder radius='sm' p='xs' bg='gray.0'>
                  <Text size='xs' c='dimmed' tt='uppercase' fw={600}>
                    Altezza
                  </Text>
                  <Text size='sm' fw={700}>
                    {formatMeasurementValue(measurement.heightCm, 'cm')}
                  </Text>
                </Paper>
              ) : null}
            </SimpleGrid>
          ) : null}

          {fields.length === 0 ? (
            <Text size='sm' c='dimmed'>
              Nessun valore registrato in questa rilevazione.
            </Text>
          ) : (
            <SimpleGrid cols={{ base: 2, sm: 3, md: 4 }} spacing='xs'>
              {fields.map(field => (
                <Paper
                  key={String(field.id)}
                  withBorder
                  radius='sm'
                  p='xs'
                  bg='gray.0'
                >
                  <Text size='xs' c='dimmed' tt='uppercase' fw={600} lh={1.2}>
                    {field.label}
                  </Text>
                  <Text size='sm' fw={700} lh={1.3}>
                    {formatMeasurementField(field)}
                  </Text>
                </Paper>
              ))}
            </SimpleGrid>
          )}

          <Stack gap={4}>
            <Text size='sm' fw={600}>
              Note
            </Text>
            <Text size='sm' c={measurement.notes.trim() ? undefined : 'dimmed'}>
              {measurement.notes.trim() || 'Nessuna nota'}
            </Text>
          </Stack>
        </Stack>
      )}
    </Modal>
  );
}
